import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "./LanguageContext";
import { projectsData } from "../data/projectsData";

const titles = {
  "/": "metadata.home", "/about": "metadata.about",
  "/projects": "nav.projects", "/skills": "nav.skills", "/experience": "career.heading",
  "/education": "learning.heading", "/certificates": "learning.heading", "/volunteer": "nav.volunteer",
  "/contact": "nav.contact",
};
const descriptions = {
  "/": "home", "/about": "about", "/projects": "projects", "/skills": "skills",
  "/experience": "experience", "/volunteer": "experience", "/education": "education",
  "/certificates": "education", "/contact": "contact",
};
export default function PageMetadata() {
  const { pathname } = useLocation();
  const { t } = useLanguage();
  useEffect(() => {
    const projectId = pathname.match(/^\/projects\/([^/]+)$/)?.[1];
    const project = projectsData.find(item => item.id === projectId);
    const title = project ? `${t(project.title)} | ${t("common.name")}` : t(titles[pathname] || "metadata.notFound");
    const description = project ? t(project.summary || project.description) : t(`metadata.${descriptions[pathname] || "notFound"}Description`);
    document.title = title;
    document.querySelector('meta[name="title"]')?.setAttribute("content", title);
    document.querySelector('meta[name="description"]')?.setAttribute("content", description);
  }, [pathname, t]);
  return null;
}
